/* Catalogs */
// Areas de capacitación
export const FETCHING_WTS_AREAS = '@@toyota/FETCHING_WTS_AREAS';
export const FETCHED_WTS_AREAS = '@@toyota/FETCHED_WTS_AREAS';
export const FETCHED_WTS_AREAS_FAILED = '@@toyota/FETCHED_WTS_AREAS_FAILED';
export const CHANGE_WTS_AREA_SELECTED = '@@toyota/CHANGE_WTS_AREA_SELECTED';

// Perfiles
export const FETCHING_WTS_PROFILES = '@@toyota/FETCHING_WTS_PROFILES';
export const FETCHED_WTS_PROFILES = '@@toyota/FETCHED_WTS_PROFILES';
export const FETCHED_WTS_PROFILES_FAILED = '@@toyota/FETCHED_WTS_PROFILES_FAILED';
export const CREATING_WTS_PROFILES = '@@toyota/CREATING_WTS_PROFILES';
export const CREATED_WTS_PROFILES = '@@toyota/CREATED_WTS_PROFILES';
export const CREATED_WTS_PROFILES_FAILED = '@@toyota/CREATED_WTS_PROFILES_FAILED';
export const UPDATING_WTS_PROFILES = '@@toyota/UPDATING_WTS_PROFILES';
export const UPDATED_WTS_PROFILES = '@@toyota/UPDATED_WTS_PROFILES';
export const UPDATED_WTS_PROFILES_FAILED = '@@toyota/UPDATED_WTS_PROFILES_FAILED';
export const CHANGE_WTS_PROFILE_SELECTED = '@@toyota/CHANGE_WTS_PROFILE_SELECTED';

// Habilidades
export const FETCHING_WTS_SKILLS = '@@toyota/FETCHING_WTS_SKILLS';
export const FETCHED_WTS_SKILLS = '@@toyota/FETCHED_WTS_SKILLS';
export const FETCHED_WTS_SKILLS_FAILED = '@@toyota/FETCHED_WTS_SKILLS_FAILED';
export const CREATING_WTS_SKILLS = '@@toyota/CREATING_WTS_SKILLS';
export const CREATED_WTS_SKILLS = '@@toyota/CREATED_WTS_SKILLS';
export const CREATED_WTS_SKILLS_FAILED = '@@toyota/CREATED_WTS_SKILLS_FAILED';
export const UPDATING_WTS_SKILLS = '@@toyota/UPDATING_WTS_SKILLS';
export const UPDATED_WTS_SKILLS = '@@toyota/UPDATED_WTS_SKILLS';
export const UPDATED_WTS_SKILLS_FAILED = '@@toyota/UPDATED_WTS_SKILLS_FAILED';
export const CHANGE_WTS_SKILL_SELECTED = '@@toyota/CHANGE_WTS_SKILL_SELECTED';

// Cargos
export const FETCHING_WTS_POSITIONS = '@@toyota/FETCHING_WTS_POSITIONS';
export const FETCHED_WTS_POSITIONS = '@@toyota/FETCHED_WTS_POSITIONS';
export const FETCHED_WTS_POSITIONS_FAILED = '@@toyota/FETCHED_WTS_POSITIONS_FAILED';
export const CREATING_WTS_POSITIONS = '@@toyota/CREATING_WTS_POSITIONS';
export const CREATED_WTS_POSITIONS = '@@toyota/CREATED_WTS_POSITIONS';
export const CREATED_WTS_POSITIONS_FAILED = '@@toyota/CREATED_WTS_POSITIONS_FAILED';
export const UPDATING_WTS_POSITIONS = '@@toyota/UPDATING_WTS_POSITIONS';
export const UPDATED_WTS_POSITIONS = '@@toyota/UPDATED_WTS_POSITIONS';
export const UPDATED_WTS_POSITIONS_FAILED = '@@toyota/UPDATED_WTS_POSITIONS_FAILED';
export const CHANGE_WTS_POSITION_SELECTED = '@@toyota/CHANGE_WTS_POSITION_SELECTED';

// Cursos
export const FETCHING_WTS_COURSES = '@@toyota/FETCHING_WTS_COURSES';
export const FETCHED_WTS_COURSES = '@@toyota/FETCHED_WTS_COURSES';
export const FETCHED_WTS_COURSES_FAILED = '@@toyota/FETCHED_WTS_COURSES_FAILED';
export const CHANGE_WTS_COURSE_FORM = '@@toyota/CHANGE_WTS_COURSE_FORM';
export const CLEAN_WTS_COURSE_FORM = '@@toyota/CLEAN_WTS_COURSE_FORM';
export const FETCHING_WTS_COURSE = '@@toyota/FETCHING_WTS_COURSE';
export const FETCHED_WTS_COURSE = '@@toyota/FETCHED_WTS_COURSE';
export const FETCHED_WTS_COURSE_FAILED = '@@toyota/FETCHED_WTS_COURSE_FAILED';
export const CREATE_WTS_COURSE = '@@toyota/CREATE_WTS_COURSE';
export const CREATED_WTS_COURSE = '@@toyota/CREATED_WTS_COURSE';
export const CREATED_WTS_COURSE_FAILED = '@@toyota/CREATED_WTS_COURSE_FAILED';
export const UPDATE_WTS_COURSE = '@@toyota/UPDATE_WTS_COURSE';
export const UPDATED_WTS_COURSE = '@@toyota/UPDATED_WTS_COURSE';
export const UPDATED_WTS_COURSE_FAILED = '@@toyota/UPDATED_WTS_COURSE_FAILED';
export const DELETING_WTS_COURSE = '@@toyota/DELETING_WTS_COURSE';
export const DELETED_WTS_COURSE = '@@toyota/DELETED_WTS_COURSE';
export const DELETED_WTS_COURSE_FAILED = '@@toyota/DELETED_WTS_COURSE_FAILED';

// Áreas de Cursos
export const FETCHING_WTS_COURSES_AREAS = '@@toyota/FETCHING_WTS_COURSES_AREAS';
export const FETCHED_WTS_COURSES_AREAS = '@@toyota/FETCHED_WTS_COURSES_AREAS';
export const FETCHED_WTS_COURSES_AREAS_FAILED = '@@toyota/FETCHED_WTS_COURSES_AREAS_FAILED';
export const CREATING_WTS_COURSES_AREAS = '@@toyota/CREATING_WTS_COURSES_AREAS';
export const CREATED_WTS_COURSES_AREAS = '@@toyota/CREATED_WTS_COURSES_AREAS';
export const CREATED_WTS_COURSES_AREAS_FAILED = '@@toyota/CREATED_WTS_COURSES_AREAS_FAILED';
export const UPDATING_WTS_COURSES_AREAS = '@@toyota/UPDATING_WTS_COURSES_AREAS';
export const UPDATED_WTS_COURSES_AREAS = '@@toyota/UPDATED_WTS_COURSES_AREAS';
export const UPDATED_WTS_COURSES_AREAS_FAILED = '@@toyota/UPDATED_WTS_COURSES_AREAS_FAILED';
export const CHANGE_WTS_COURSE_AREA_SELECTED = '@@toyota/CHANGE_WTS_COURSE_AREA_SELECTED';
export const CLEAR_WTS_AREAS = '@@toyota/CLEAR_WTS_AREAS';
export const FETCHING_WTS_COURSES_FILTER = '@@toyota/FETCHING_WTS_COURSES_FILTER';
export const FETCHED_WTS_COURSES_FILTER = '@@toyota/FETCHED_WTS_COURSES_FILTER';
export const FETCHED_WTS_COURSES_FILTER_FAILED = '@@toyota/FETCHED_WTS_COURSES_FILTER_FAILED';

// Areas de cursos administador
export const FETCHING_WTS_COURSES_AREAS_ADMINISTRADOR = '@@toyota/FETCHING_WTS_COURSES_AREAS_ADMINISTRADOR';
export const FETCHED_WTS_COURSES_AREAS_ADMINISTRADOR = '@@toyota/FETCHED_WTS_COURSES_AREAS_ADMINISTRADOR';
export const FETCHED_WTS_COURSES_AREAS_FAILED_ADMINISTRADOR = '@@toyota/FETCHED_WTS_COURSES_AREAS_FAILED_ADMINISTRADOR';

// Estados de Cursos
export const FETCHING_WTS_COURSES_STATUS = '@@toyota/FETCHING_WTS_COURSES_STATUS';
export const FETCHED_WTS_COURSES_STATUS = '@@toyota/FETCHED_WTS_COURSES_STATUS';
export const FETCHED_WTS_COURSES_STATUS_FAILED = '@@toyota/FETCHED_WTS_COURSES_STATUS_FAILED';
export const CREATING_WTS_COURSES_STATUS = '@@toyota/CREATING_WTS_COURSES_STATUS';
export const CREATED_WTS_COURSES_STATUS = '@@toyota/CREATED_WTS_COURSES_STATUS';
export const CREATED_WTS_COURSES_STATUS_FAILED = '@@toyota/CREATED_WTS_COURSES_STATUS_FAILED';
export const UPDATING_WTS_COURSES_STATUS = '@@toyota/UPDATING_WTS_COURSES_STATUS';
export const UPDATED_WTS_COURSES_STATUS = '@@toyota/UPDATED_WTS_COURSES_STATUS';
export const UPDATED_WTS_COURSES_STATUS_FAILED = '@@toyota/UPDATED_WTS_COURSES_STATUS_FAILED';
export const CHANGE_WTS_COURSE_STATUS_SELECTED = '@@toyota/CHANGE_WTS_COURSE_STATUS_SELECTED';
// Concecionario
export const FETCHING_WTS_DEALER = '@@toyota/FETCHING_WTS_DEALER';
export const FETCHED_WTS_DEALER = '@@toyota/FETCHED_WTS_DEALER';
export const FETCHED_WTS_DEALER_FAILED = '@@toyota/FETCHED_WTS_DEALER_FAILED';
export const UPDATING_WTS_DEALER_STATUS = '@@toyota/UPDATING_WTS_DEALER_STATUS';
export const UPDATED_WTS_DEALER_STATUS = '@@toyota/UPDATED_WTS_DEALER_STATUS';
export const UPDATED_WTS_DEALER_STATUS_FAILED = '@@toyota/UPDATED_WTS_DEALER_STATUS_FAILED';
export const CHANGE_WTS_DEALER_SELECTED = '@@toyota/CHANGE_WTS_DEALER_SELECTED';
export const UPDATING_WTS_DEALER = '@@toyota/UPDATING_WTS_DEALER';
export const UPDATED_WTS_DEALER = '@@toyota/UPDATED_WTS_DEALER';
export const UPDATED_WTS_DEALER_FAILED = '@@toyota/UPDATED_WTS_DEALER_FAILED';
export const CREATING_WTS_DEALER = '@@toyota/CREATING_WTS_DEALER';
export const CREATED_WTS_DEALER = '@@toyota/CREATED_WTS_DEALER';
export const CREATED_WTS_DEALER_FAILED = '@@toyota/CREATED_WTS_DEALER_FAILED';
// Agencias
export const FETCHING_WTS_AGENCIES = '@@toyota/FETCHING_WTS_AGENCIES';
export const FETCHED_WTS_AGENCIES = '@@toyota/FETCHED_WTS_AGENCIES';
export const FETCHED_WTS_AGENCIES_FAILED = '@@toyota/FETCHED_WTS_AGENCIES_FAILED';
export const UPDATING_WTS_AGENCIES_STATUS = '@@toyota/UPDATING_WTS_AGENCIES_STATUS';
export const UPDATED_WTS_AGENCIES_STATUS = '@@toyota/UPDATED_WTS_AGENCIES_STATUS';
export const UPDATED_WTS_AGENCIES_STATUS_FAILED = '@@toyota/UPDATED_WTS_AGENCIES_STATUS_FAILED';
export const CHANGE_WTS_AGENCY_SELECTED = '@@toyota/CHANGE_WTS_AGENCY_SELECTED';
export const UPDATING_WTS_AGENCIES = '@@toyota/UPDATING_WTS_AGENCIES';
export const UPDATED_WTS_AGENCIES = '@@toyota/UPDATED_WTS_AGENCIES';
export const UPDATED_WTS_AGENCIES_FAILED = '@@toyota/UPDATED_WTS_AGENCIES_FAILED';
export const CREATING_WTS_AGENCIES = '@@toyota/CREATING_WTS_AGENCIES';
export const CREATED_WTS_AGENCIES = '@@toyota/CREATED_WTS_AGENCIES';
export const CREATED_WTS_AGENCIES_FAILED = '@@toyota/CREATED_WTS_AGENCIES_FAILED';
export const FETCHING_WTS_AGENCIES_DEALER = '@@toyota/FETCHING_WTS_AGENCIES_DEALER';
export const FETCHED_WTS_AGENCIES_DEALER = '@@toyota/FETCHED_WTS_AGENCIES_DEALER';
export const FETCHED_WTS_AGENCIES_DEALER_FAILED = '@@toyota/FETCHED_WTS_AGENCIES_DEALER_FAILED';

// Empleados
export const FETCHING_WTS_EMPLOYEES_GESTOR = '@@toyota/FETCHING_WTS_EMPLOYEES_GESTOR';
export const FETCHED_WTS_EMPLOYEES_GESTOR = '@@toyota/FETCHED_WTS_EMPLOYEES_GESTOR';
export const FETCHED_WTS_EMPLOYEES_GESTOR_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEES_GESTOR_FAILED';
export const FETCHING_WTS_EMPLOYEES_EVALUATOR = '@@toyota/FETCHING_WTS_EMPLOYEES_EVALUATOR';
export const FETCHED_WTS_EMPLOYEES_EVALUATOR = '@@toyota/FETCHED_WTS_EMPLOYEES_EVALUATOR';
export const FETCHED_WTS_EMPLOYEES_EVALUATOR_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEES_EVALUATOR_FAILED';
export const UPDATING_WTS_EMPLOYEES_STATUS = '@@toyota/UPDATING_WTS_EMPLOYEES_STATUS';
export const UPDATED_WTS_EMPLOYEES_STATUS = '@@toyota/UPDATED_WTS_EMPLOYEES_STATUS';
export const UPDATED_WTS_EMPLOYEES_STATUS_FAILED = '@@toyota/UPDATED_WTS_EMPLOYEES_STATUS_FAILED';
export const CHANGE_WTS_EMPLOYEE_SELECTED = '@@toyota/CHANGE_WTS_EMPLOYEE_SELECTED';
export const CREATING_WTS_EMPLOYEE = '@@toyota/CREATING_WTS_EMPLOYEE';
export const CREATED_WTS_EMPLOYEE = '@@toyota/CREATED_WTS_EMPLOYEE';
export const CREATED_WTS_EMPLOYEE_FAILED = '@@toyota/CREATED_WTS_EMPLOYEE_FAILED';
export const UPDATING_WTS_EMPLOYEE = '@@toyota/UPDATING_WTS_EMPLOYEE';
export const UPDATED_WTS_EMPLOYEE = '@@toyota/UPDATED_WTS_EMPLOYEE';
export const UPDATED_WTS_EMPLOYEE_FAILED = '@@toyota/UPDATED_WTS_EMPLOYEE_FAILED';
export const FETCHING_WTS_EMPLOYEES_BY_CHARGE = '@@toyota/FETCHING_WTS_EMPLOYEES_BY_CHARGE';
export const FETCHED_WTS_EMPLOYEES_BY_CHARGE = '@@toyota/FETCHED_WTS_EMPLOYEES_BY_CHARGE';
export const FETCHED_WTS_EMPLOYEES_BY_CHARGE_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEES_BY_CHARGE_FAILED';
export const FETCHING_WTS_EMPLOYEE_BY_ID = '@@toyota/FETCHING_WTS_EMPLOYEE_BY_ID';
export const FETCHED_WTS_EMPLOYEE_BY_ID = '@@toyota/FETCHED_WTS_EMPLOYEE_BY_ID';
export const FETCHED_WTS_EMPLOYEE_BY_ID_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_BY_ID_FAILED';
export const FETCHING_WTS_EMPLOYEE_BY_EMAIL = '@@toyota/FETCHING_WTS_EMPLOYEE_BY_EMAIL';
export const FETCHED_WTS_EMPLOYEE_BY_EMAIL = '@@toyota/FETCHED_WTS_EMPLOYEE_BY_EMAIL';
export const FETCHED_WTS_EMPLOYEE_BY_EMAIL_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_BY_EMAIL_FAILED';

// CourseAgenda
export const FETCHING_WTS_AGENDAS = '@@toyota/FETCHING_WTS_AGENDAS';
export const FETCHED_WTS_AGENDAS = '@@toyota/FETCHED_WTS_AGENDAS';
export const FETCHED_WTS_AGENDAS_FAILED = '@@toyota/FETCHED_WTS_AGENDAS_FAILED';
export const CREATING_WTS_AGENDA = '@@toyota/CREATING_WTS_AGENDA';
export const CREATED_WTS_AGENDA = '@@toyota/CREATED_WTS_AGENDA';
export const CREATED_WTS_AGENDA_FAILED = '@@toyota/CREATED_WTS_AGENDA_FAILED';
export const UPDATING_WTS_AGENDA = '@@toyota/UPDATING_WTS_AGENDA';
export const UPDATED_WTS_AGENDA = '@@toyota/UPDATED_WTS_AGENDA';
export const UPDATED_WTS_AGENDA_FAILED = '@@toyota/UPDATED_WTS_AGENDA_FAILED';
export const DELETING_WTS_AGENDA = '@@toyota/DELETING_WTS_AGENDA';
export const DELETED_WTS_AGENDA = '@@toyota/DELETED_WTS_AGENDA';
export const DELETED_WTS_AGENDA_FAILED = '@@toyota/DELETED_WTS_AGENDA_FAILED';
export const FETCHING_WTS_AGENDA_LAST_ID = '@@toyota/FETCHING_WTS_AGENDA_LAST_ID';
export const FETCHED_WTS_AGENDA_LAST_ID = '@@toyota/FETCHED_WTS_AGENDA_LAST_ID';
export const FETCHED_WTS_AGENDA_LAST_ID_FAILED = '@@toyota/FETCHED_WTS_AGENDA_LAST_ID_FAILED';

// Course Agenda Dealers
export const FETCHING_WTS_AGENDA_DEALERS = '@@toyota/FETCHING_WTS_AGENDA_DEALERS';
export const FETCHED_WTS_AGENDA_DEALERS = '@@toyota/FETCHED_WTS_AGENDA_DEALERS';
export const FETCHED_WTS_AGENDA_DEALERS_FAILED = '@@toyota/FETCHED_WTS_AGENDA_DEALERS_FAILED';
export const CREATING_WTS_AGENDA_DEALER = '@@toyota/CREATING_WTS_AGENDA_DEALER';
export const CREATED_WTS_AGENDA_DEALER = '@@toyota/CREATED_WTS_AGENDA_DEALER';
export const CREATED_WTS_AGENDA_DEALER_FAILED = '@@toyota/CREATED_WTS_AGENDA_DEALER_FAILED';
export const UPDATING_WTS_AGENDA_DEALER = '@@toyota/UPDATING_WTS_AGENDA_DEALER';
export const UPDATED_WTS_AGENDA_DEALER = '@@toyota/UPDATED_WTS_AGENDA_DEALER';
export const UPDATED_WTS_AGENDA_DEALER_FAILED = '@@toyota/UPDATED_WTS_AGENDA_DEALER_FAILED';
export const DELETING_WTS_AGENDA_DEALER = '@@toyota/DELETING_WTS_AGENDA_DEALER';
export const DELETED_WTS_AGENDA_DEALER = '@@toyota/DELETED_WTS_AGENDA_DEALER';
export const DELETED_WTS_AGENDA_DEALER_FAILED = '@@toyota/DELETED_WTS_AGENDA_DEALER_FAILED';
export const FETCHING_WTS_AGENDA_DEALER_LAST_ID = '@@toyota/FETCHING_WTS_AGENDA_DEALER_LAST_ID';
export const FETCHED_WTS_AGENDA_DEALER_LAST_ID = '@@toyota/FETCHED_WTS_AGENDA_DEALER_LAST_ID';
export const FETCHED_WTS_AGENDA_DEALER_LAST_ID_FAILED = '@@toyota/FETCHED_WTS_AGENDA_DEALER_LAST_ID_FAILED';

// wts auth
export const CREATING_WTS_USER = 'CREATING_WTS_USER';
export const CREATED_WTS_USER = 'CREATED_WTS_USER';
export const CREATED_WTS_USER_FAILED = 'CREATED_WTS_USER_FAILED';
export const FETCHING_WTS_USER = 'FETCHING_WTS_USER';
export const FETCHED_WTS_USER = 'FETCHED_WTS_USER';
export const FETCHED_WTS_USER_FAILED = 'FETCHED_WTS_USER_FAILED';
export const UPDATING_WTS_USER = 'UPDATING_WTS_USER';
export const UPDATED_WTS_USER = 'UPDATED_WTS_USER';
export const UPDATED_WTS_USER_FAILED = 'UPDATED_WTS_USER_FAILED';
export const CLEAR_WTS_USER = 'CLEAR_WTS_USER';

// wts notify
export const CREATING_WTS_USER_NOTIFY = 'CREATING_WTS_USER_NOTIFY';
export const CREATED_WTS_USER_NOTIFY = 'CREATED_WTS_USER_NOTIFY';
export const CREATED_WTS_USER_NOTIFY_FAILED = 'CREATED_WTS_USER_NOTIFY_FAILED';
export const CREATING_WTS_COURSE_NOTIFY = 'CREATING_WTS_COURSE_NOTIFY';
export const CREATED_WTS_COURSE_NOTIFY = 'CREATED_WTS_COURSE_NOTIFY';
export const CREATED_WTS_COURSE_NOTIFY_FAILED = 'CREATED_WTS_COURSE_NOTIFY_FAILED';
export const UPDATING_WTS_USER_NOTIFY = 'UPDATING_WTS_USER_NOTIFY';
export const UPDATED_WTS_USER_NOTIFY = 'UPDATED_WTS_USER_NOTIFY';
export const UPDATED_WTS_USER_NOTIFY_FAILED = 'UPDATED_WTS_USER_NOTIFY_FAILED';
export const UPDATING_WTS_COURSE_NOTIFY = 'UPDATING_WTS_COURSE_NOTIFY';
export const UPDATED_WTS_COURSE_NOTIFY = 'UPDATED_WTS_COURSE_NOTIFY';
export const UPDATED_WTS_COURSE_NOTIFY_FAILED = 'UPDATED_WTS_COURSE_NOTIFY_FAILED';
export const CLOSING_WTS_COURSE_NOTIFY = 'CLOSING_WTS_COURSE_NOTIFY';
export const CLOSED_WTS_COURSE_NOTIFY = 'CLOSED_WTS_COURSE_NOTIFY';
export const CLOSED_WTS_COURSE_NOTIFY_FAILED = 'CLOSED_WTS_COURSE_NOTIFY_FAILED';
export const CANCELLING_WTS_COURSE_NOTIFY = 'CANCELLING_WTS_COURSE_NOTIFY';
export const CANCELLED_WTS_COURSE_NOTIFY = 'CANCELLED_WTS_COURSE_NOTIFY';
export const CANCELLED_WTS_COURSE_NOTIFY_FAILED = 'CANCELLED_WTS_COURSE_NOTIFY_FAILED';

// wts paras
export const CREATING_WTS_PARAM = 'CREATING_WTS_PARAM';
export const CREATED_WTS_PARAM = 'CREATED_WTS_PARAM';
export const CREATED_WTS_PARAM_FAILED = 'CREATED_WTS_PARAM_FAILED';
export const FETCHING_WTS_PARAMS = 'FETCHING_WTS_PARAMS';
export const FETCHED_WTS_PARAMS = 'FETCHED_WTS_PARAMS';
export const FETCHED_WTS_PARAMS_FAILED = 'FETCHED_WTS_PARAMS_FAILED';
export const FETCHING_WTS_PARAM = 'FETCHING_WTS_PARAM';
export const FETCHED_WTS_PARAM = 'FETCHED_WTS_PARAM';
export const FETCHED_WTS_PARAM_FAILED = 'FETCHED_WTS_PARAM_FAILED';
export const UPDATING_WTS_PARAM = 'UPDATING_WTS_PARAM';
export const UPDATED_WTS_PARAM = 'UPDATED_WTS_PARAM';
export const UPDATED_WTS_PARAM_FAILED = 'UPDATED_WTS_PARAM_FAILED';
export const DELETING_WTS_PARAM = 'DELETING_WTS_PARAM';
export const DELETED_WTS_PARAM = 'DELETED_WTS_PARAM';
export const DELETED_WTS_PARAM_FAILED = 'DELETED_WTS_PARAM_FAILED';
export const CHANGE_WTS_PARAM_SELECTED = 'CHANGE_WTS_PARAM_SELECTED';
export const CLEAR_WTS_PARAM = 'CLEAR_WTS_PARAM';

// DOCUMENTOS WTS
export const FETCHING_WTS_COURSE_DOCS = 'FETCHING_WTS_COURSE_DOCS';
export const FETCHED_WTS_COURSE_DOCS = 'FETCHED_WTS_COURSE_DOCS';
export const FETCHED_WTS_COURSE_DOCS_FAILED = 'FETCHED_WTS_COURSE_DOCS_FAILED';
export const CREATING_WTS_COURSE_DOC = 'CREATING_WTS_COURSE_DOC';
export const CREATED_WTS_COURSE_DOC = 'CREATED_WTS_COURSE_DOC';
export const CREATED_WTS_COURSE_DOC_FAILED = 'CREATED_WTS_COURSE_DOC_FAILED';
export const UPDATING_WTS_COURSE_DOC = 'UPDATING_WTS_COURSE_DOC';
export const UPDATED_WTS_COURSE_DOC = 'UPDATED_WTS_COURSE_DOC';
export const UPDATED_WTS_COURSE_DOC_FAILED = 'UPDATED_WTS_COURSE_DOC_FAILED';
export const DELETING_WTS_COURSE_DOC = 'DELETING_WTS_COURSE_DOC';
export const DELETED_WTS_COURSE_DOC = 'DELETED_WTS_COURSE_DOC';
export const DELETED_WTS_COURSE_DOC_FAILED = 'DELETED_WTS_COURSE_DOC_FAILED';
export const FETCHING_WTS_COURSE_DOC_FILE = 'FETCHING_WTS_COURSE_DOC_FILE';
export const FETCHED_WTS_COURSE_DOC_FILE = 'FETCHED_WTS_COURSE_DOC_FILE';
export const FETCHED_WTS_COURSE_DOC_FILE_FAILED = 'FETCHED_WTS_COURSE_DOC_FILE_FAILED';
export const CLEAR_WTS_COURSE_DOCS = 'CLEAR_WTS_COURSE_DOCS';


// employeeCert
export const FETCHING_WTS_EMPLOYEES_BY_CERTS = 'FETCHING_WTS_EMPLOYEES_BY_CERTS';
export const FETCHED_WTS_EMPLOYEES_BY_CERTS = 'FETCHED_WTS_EMPLOYEES_BY_CERTS';
export const FETCHED_WTS_EMPLOYEES_BY_CERTS_FAILED = 'FETCHED_WTS_EMPLOYEES_BY_CERTS_FAILED';
export const FETCHING_WTS_CERTS = 'FETCHING_WTS_CERTS';
export const FETCHED_WTS_CERTS = 'FETCHED_WTS_CERTS';
export const FETCHED_WTS_CERTS_FAILED = 'FETCHED_WTS_CERTS_FAILED';
export const FETCHING_WTS_EMPLOYEE_CERTS = 'FETCHING_WTS_EMPLOYEE_CERTS';
export const FETCHED_WTS_EMPLOYEE_CERTS = 'FETCHED_WTS_EMPLOYEE_CERTS';
export const FETCHED_WTS_EMPLOYEE_CERTS_FAILED = 'FETCHED_WTS_EMPLOYEE_CERTS_FAILED';
export const FETCHING_WTS_EMPLOYEES_BY_RUC = 'FETCHING_WTS_EMPLOYEES_BY_RUC';
export const FETCHED_WTS_EMPLOYEES_BY_RUC = 'FETCHED_WTS_EMPLOYEES_BY_RUC';
export const FETCHED_WTS_EMPLOYEES_BY_RUC_FAILED = 'FETCHED_WTS_EMPLOYEES_BY_RUC_FAILED';


// EmployeeMatricula
export const FETCHING_WTS_MATRICULAS = 'FETCHING_WTS_MATRICULAS';
export const FETCHED_WTS_MATRICULAS = 'FETCHED_WTS_MATRICULAS';
export const FETCHED_WTS_MATRICULAS_FAILED = 'FETCHED_WTS_MATRICULAS_FAILED';
export const CREATING_WTS_MATRICULAS = 'CREATING_WTS_MATRICULAS';
export const CREATED_WTS_MATRICULAS = 'CREATED_WTS_MATRICULAS';
export const CREATED_WTS_MATRICULAS_FAILED = 'CREATED_WTS_MATRICULAS_FAILED';
export const UPDATING_WTS_MATRICULA = 'UPDATING_WTS_MATRICULA';
export const UPDATED_WTS_MATRICULA = 'UPDATED_WTS_MATRICULA';
export const UPDATED_WTS_MATRICULA_FAILED = 'UPDATED_WTS_MATRICULA_FAILED';
export const FETCHING_WTS_MATRICULAS_HISTORY = 'FETCHING_WTS_MATRICULAS_HISTORY';
export const FETCHED_WTS_MATRICULAS_HISTORY = 'FETCHED_WTS_MATRICULAS_HISTORY';
export const FETCHED_WTS_MATRICULAS_HISTORY_FAILED = 'FETCHED_WTS_MATRICULAS_HISTORY_FAILED';


// Registro de Trabajo de Agencias
export const FETCHING_TRABAJO_AGENCIAS = '@@toyota/FETCHING_TRABAJO_AGENCIAS';
export const FETCHED_TRABAJO_AGENCIAS = '@@toyota/FETCHED_TRABAJO_AGENCIAS';
export const FETCHED_TRABAJO_AGENCIAS_FAILED = '@@toyota/FETCHED_TRABAJO_AGENCIAS_FAILED';
export const CREATING_TRABAJO_AGENCIA = '@@toyota/CREATING_TRABAJO_AGENCIA';
export const CREATED_TRABAJO_AGENCIA = '@@toyota/CREATED_TRABAJO_AGENCIA';
export const CREATED_TRABAJO_AGENCIA_FAILED = '@@toyota/CREATED_TRABAJO_AGENCIA_FAILED';
export const UPDATING_TRABAJO_AGENCIA = '@@toyota/UPDATING_TRABAJO_AGENCIA';
export const UPDATED_TRABAJO_AGENCIA = '@@toyota/UPDATED_TRABAJO_AGENCIA';
export const UPDATED_TRABAJO_AGENCIA_FAILED = '@@toyota/UPDATED_TRABAJO_AGENCIA_FAILED';

// certificados
export const FETCHING_WTS_CERTIFICACION = '@@toyota/FETCHING_WTS_CERTIFICACION';
export const FETCHED_WTS_CERTIFICACION = '@@toyota/FETCHED_WTS_CERTIFICACION';
export const FETCHED_WTS_CERTIFICACION_FAILED = '@@toyota/FETCHED_WTS_CERTIFICACION_FAILED';
export const CREATING_WTS_CERTIFICACION = '@@toyota/CREATING_WTS_CERTIFICACION';
export const CREATED_WTS_CERTIFICACION = '@@toyota/CREATED_WTS_CERTIFICACION';
export const CREATED_WTS_CERTIFICACION_FAILED = '@@toyota/CREATED_WTS_CERTIFICACION_FAILED';
export const UPDATING_WTS_CERTIFICACION = '@@toyota/UPDATING_WTS_CERTIFICACION';
export const UPDATED_WTS_CERTIFICACION = '@@toyota/UPDATED_WTS_CERTIFICACION';
export const UPDATED_WTS_CERTIFICACION_FAILED = '@@toyota/UPDATED_WTS_CERTIFICACION_FAILED';
export const DELETING_WTS_CERTIFICACION = '@@toyota/DELETING_WTS_CERTIFICACION';
export const DELETED_WTS_CERTIFICACION = '@@toyota/DELETED_WTS_CERTIFICACION';
export const DELETED_WTS_CERTIFICACION_FAILED = '@@toyota/DELETED_WTS_CERTIFICACION_FAILED';


// Employee Notify ADM
export const FETCHING_WTS_EMPLOYEE_NOTIFY_ADM = '@@toyota/FETCHING_WTS_EMPLOYEE_NOTIFY_ADM';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_ADM = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_ADM';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_ADM_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_ADM_FAILED';

// Employee Notify EVA
export const FETCHING_WTS_EMPLOYEE_NOTIFY_EVA = '@@toyota/FETCHING_WTS_EMPLOYEE_NOTIFY_EVA';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_EVA = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_EVA';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_EVA_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_EVA_FAILED';

// Employee Notify GES
export const FETCHING_WTS_EMPLOYEE_NOTIFY_GES = '@@toyota/FETCHING_WTS_EMPLOYEE_NOTIFY_GES';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_GES = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_GES';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_GES_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_GES_FAILED';

// Employee Notify TEC
export const FETCHING_WTS_EMPLOYEE_NOTIFY_TEC = '@@toyota/FETCHING_WTS_EMPLOYEE_NOTIFY_TEC';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_TEC = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_TEC';
export const FETCHED_WTS_EMPLOYEE_NOTIFY_TEC_FAILED = '@@toyota/FETCHED_WTS_EMPLOYEE_NOTIFY_TEC_FAILED';
